
import api from '../../../util/api';
import router from '../../../router';

const login = "/api-token-auth/";
const recovery = "/interface/v1/password-recovery/";
const password = "/interface/v1/password-change/";
const url = "/interface/v1/profile/"

export default {
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.post(login, data)
        .then(res => res.json())
        .then(data => {
          if (data.token && data.token !== "") {
            commit("set", { token: data.token, authenticated: true });
            localStorage.setItem("auth_token", data.token);
            api.findToken();
            console.log("token", data);
            api.get(url).then(data => data.json()).then(resp => {
              commit("profile", {
                admin: resp[0].is_admin,
                vm: resp[0].is_vm,
                imach: resp[0].is_imach,
                maintainer: resp[0].maintainer,
                company: resp[0].company,
                parent_company: resp[0].parent_company
              })
              console.log('action aut', resp)
              localStorage.setItem("admin", resp[0].is_admin)
              localStorage.setItem("vm", resp[0].is_vm)
              localStorage.setItem("imach", resp[0].is_imach)
              localStorage.setItem("maintainer", resp[0].is_maintainer)
              localStorage.setItem("company", resp[0].company)
              localStorage.setItem("parent_company", resp[0].parent_company)
              resolve(data);
            })
          } else {
            reject(data);
          }
        }).catch(err => console.log(err));
    });
  },
  logout({ commit }) {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("admin")
    localStorage.removeItem("vm")
    localStorage.removeItem("imach")
    localStorage.removeItem("maintainer")
    localStorage.removeItem("company")
    localStorage.removeItem("imachCia")
    localStorage.removeItem("parent_company")
    localStorage.removeItem("imachCiaID")
    commit("set", { token: null, authenticated: false });
    router.replace({ name: "Login" });
  },

  async recoverPassword({ commit }, { item }) {
    try {
      console.log("recovery", item)
      const res = await api.post(recovery, item);
      const data = await res.json();
      return data;
    } catch (err) {
      throw new Error(err);
    }
  },

  async changePassword({ commit }, { item }) {
    try {
      const res = await api.put(password, item);
      const data = await res.json();
      return data;
    } catch (err) {
      throw new Error(err);
    }
  },

}